var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent, Fragment, createElement } from 'react';
import PropTypes from 'prop-types';
import { Popover as AntPopover, Icon as AntIcon, Modal as AntModal, Tooltip as AntTooltip } from 'antd';
import { filter, map } from 'lodash';
import classNames from 'classnames';
import { services, ComponentsManager } from '@comall-backend-builder/core';
import { CarouselAPI, Carousel } from '../carousel';
/**
 * 可预览的最多图片数量，默认为4张
 */

var MAX_COUNT = 4;
/**
 * 气泡框位置
 */

var PopoverPlacementAPI;

(function (PopoverPlacementAPI) {
  PopoverPlacementAPI["topLeft"] = "topLeft";
  PopoverPlacementAPI["top"] = "top";
  PopoverPlacementAPI["topRight"] = "topRight";
  PopoverPlacementAPI["leftTop"] = "leftTop";
  PopoverPlacementAPI["left"] = "left";
  PopoverPlacementAPI["leftBottom"] = "leftBottom";
  PopoverPlacementAPI["rightTop"] = "rightTop";
  PopoverPlacementAPI["right"] = "right";
  PopoverPlacementAPI["rightBottom"] = "rightBottom";
  PopoverPlacementAPI["bottomLeft"] = "bottomLeft";
  PopoverPlacementAPI["bottom"] = "bottom";
  PopoverPlacementAPI["bottomRight"] = "bottomRight";
})(PopoverPlacementAPI || (PopoverPlacementAPI = {}));
/**
 * 气泡触发事件
 */


var PopoverTriggerAPI;

(function (PopoverTriggerAPI) {
  PopoverTriggerAPI["click"] = "click";
  PopoverTriggerAPI["hover"] = "hover";
})(PopoverTriggerAPI || (PopoverTriggerAPI = {}));

var ImagePreview = function (_super) {
  __extends(ImagePreview, _super);

  function ImagePreview(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      modalPreviewVisible: false,
      activePanel: 0
    };
    _this.renderImagePreview = _this.renderImagePreview.bind(_this);
    _this.renderModalPreview = _this.renderModalPreview.bind(_this);
    _this.renderPopoverPreview = _this.renderPopoverPreview.bind(_this);
    _this.handleOpenModal = _this.handleOpenModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    return _this;
  }

  ImagePreview.prototype.render = function () {
    var _a = this.props,
        style = _a.style,
        className = _a.className;
    return React.createElement("div", {
      className: classNames('image-preview-container', className),
      style: style
    }, this.renderImagePreview());
  };
  /**
   * 配置preview时，显示图片预览
   * 多张图片，则使用modal
   * 单张图片，则使用popover
   */


  ImagePreview.prototype.renderImagePreview = function () {
    var _a = this.props,
        imageConfig = _a.imageConfig,
        items = _a.items,
        visible = _a.visible,
        type = _a.type,
        maxCount = _a.maxCount,
        icon = _a.icon;

    if (type === 'modal') {
      var style_1 = imageConfig.style; // 图片内容

      var imageItems = filter(items, function (_item, index) {
        return index < (maxCount || MAX_COUNT);
      }).map(function (item, index) {
        return React.createElement("div", {
          className: "modal-preview-container",
          key: index,
          style: {
            width: style_1 && style_1.width
          }
        }, React.createElement("img", __assign({}, imageConfig, {
          src: item,
          alt: item
        })));
      });

      var iconProps = __assign(__assign({}, icon), {
        onClick: this.handleOpenModal
      }); // modal层内容


      var modalPreview = React.createElement(Fragment, null, React.createElement(AntTooltip, {
        title: services.language.getText('common.preview')
      }, React.createElement(AntIcon, __assign({
        className: "image-preview-icon"
      }, iconProps))), this.renderModalPreview());
      return React.createElement(Fragment, null, React.createElement("div", {
        className: "image-list"
      }, imageItems), visible ? modalPreview : null);
    } else if (type === 'popover') {
      return React.createElement(Fragment, null, React.createElement("div", {
        className: "popover-preview-container"
      }, React.createElement("img", __assign({}, imageConfig, {
        alt: imageConfig.alt
      }))), visible ? this.renderPopoverPreview() : null);
    } else {
      return undefined;
    }
  };
  /**
   * 打开 modal
   */


  ImagePreview.prototype.handleOpenModal = function () {
    this.setState({
      modalPreviewVisible: true
    });
  };
  /**
   * 关闭 modal
   */


  ImagePreview.prototype.handleCloseModal = function () {
    this.setState({
      modalPreviewVisible: false
    });
  };
  /**
   * 图片预览：modal
   */


  ImagePreview.prototype.renderModalPreview = function () {
    var _a = this.state,
        modalPreviewVisible = _a.modalPreviewVisible,
        activePanel = _a.activePanel;
    var _b = this.props,
        size = _b.size,
        autoplay = _b.autoplay,
        showArrows = _b.showArrows,
        dots = _b.dots,
        easing = _b.easing,
        effect = _b.effect,
        vertical = _b.vertical,
        items = _b.items,
        component = _b.component,
        config = _b.config;
    var modalProps = {
      visible: modalPreviewVisible,
      footer: null,
      onCancel: this.handleCloseModal,
      width: size
    }; // 原数据集items需要格式化，在preview中显示

    var formatArray = new Array();
    map(items, function (item, key) {
      formatArray.push(__assign({
        id: key,
        imageurl: item,
        text: item,
        component: component
      }, config));
    });
    var carouselProps = {
      className: 'modal-carousel',
      autoplay: autoplay,
      showArrows: showArrows,
      dots: dots,
      easing: easing,
      effect: effect,
      vertical: vertical,
      items: formatArray,
      activePanel: activePanel
    };
    return React.createElement(AntModal, __assign({}, modalProps), React.createElement(Carousel, __assign({}, carouselProps)));
  };
  /**
   * 图片预览：popover
   */


  ImagePreview.prototype.renderPopoverPreview = function () {
    var _a = this.props,
        size = _a.size,
        title = _a.title,
        trigger = _a.trigger,
        placement = _a.placement,
        _b = _a.imageConfig,
        className = _b.className,
        style = _b.style,
        src = _b.src,
        alt = _b.alt,
        component = _a.component,
        config = _a.config;

    var popoverImageProps = __assign({
      imageurl: src,
      text: alt,
      style: {
        width: size
      }
    }, config);

    var content = React.createElement("div", {
      className: "popover-image"
    }, createElement(ComponentsManager.get(component), popoverImageProps));
    var popoverProps = {
      title: title,
      trigger: trigger,
      placement: placement,
      content: content
    };
    var imageProps = {
      className: className,
      style: style,
      src: src,
      alt: alt
    };
    return React.createElement("div", {
      className: "popover-preview"
    }, React.createElement(AntPopover, __assign({}, popoverProps), React.createElement("img", __assign({}, imageProps, {
      alt: alt
    }))));
  };

  ImagePreview.defaultProps = {
    // 默认不可预览
    visible: false,
    // 默认可展示的图片数量
    maxCount: MAX_COUNT,
    // 查看图片时的icon配置
    icon: {
      type: 'ellipsis'
    },
    component: 'Image'
  };
  ImagePreview.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    // 预览：配置类型，仅有可预览／不可预览
    visible: PropTypes.bool,
    // 预览：尺寸
    size: PropTypes.number,
    // 预览：可展示的图片数量
    maxCount: PropTypes.number,
    // 预览：modal 配置
    autoplay: PropTypes.bool,
    showArrows: PropTypes.bool,
    dots: PropTypes.bool,
    easing: PropTypes.oneOf([CarouselAPI.linear, CarouselAPI.swing]),
    effect: PropTypes.oneOf([CarouselAPI.scrollx, CarouselAPI.fade]),
    vertical: PropTypes.bool,
    // 预览：popover 配置
    title: PropTypes.string,
    trigger: PropTypes.oneOf([PopoverTriggerAPI.click, PopoverTriggerAPI.hover]),
    placement: PropTypes.oneOf([PopoverPlacementAPI.topLeft, PopoverPlacementAPI.top, PopoverPlacementAPI.topRight, PopoverPlacementAPI.leftTop, PopoverPlacementAPI.left, PopoverPlacementAPI.leftBottom, PopoverPlacementAPI.rightTop, PopoverPlacementAPI.right, PopoverPlacementAPI.rightBottom, PopoverPlacementAPI.bottomLeft, PopoverPlacementAPI.bottom, PopoverPlacementAPI.bottomRight]),
    // 预览：多条预览数据，用于modal预览
    items: PropTypes.array,
    // 图片配置
    imageConfig: PropTypes.shape({
      className: PropTypes.string,
      style: PropTypes.object,
      src: PropTypes.string,
      alt: PropTypes.string
    })
  };
  return ImagePreview;
}(PureComponent);

export { ImagePreview };